import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'

class BuyConnectButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      popUpOpen: false,
    }

    this.togglePopUp = this.togglePopUp.bind(this)
  }

  togglePopUp() {
    this.setState({
      popUpOpen: !this.state.popUpOpen
    })
  }

  render() {
    return(
      <div>
        <button onClick={this.togglePopUp} className="btn_primary">Connect</button>
        {this.state.popUpOpen &&
          <StandardModal onClose={() => this.togglePopUp()}>
            <div style={{alignSelf: 'flex-end', display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
              <h6 className="sectionText">You have</h6><h6 className="sectionText" style={{fontWeight: 700, paddingLeft: 3, paddingRight: 3}}> 0 </h6>
              <div className="lexicoin" style={{width: 20, height: 20, marginTop: -3}}></div>
            </div>
            <h3 className="red bold" style={{textAlign: 'center'}}>You have 0 Lexicoins!</h3>
            <h4 className="darkBlue" style={{paddingTop: 10, paddingBottom: 20, fontWeight: 300, textAlign: 'center'}}>Sending a request costs 1 Lexicoin</h4>
            <div className="lexicoin" style={{width: 60, height: 60, marginBottom: 30, margin: 'auto'}}></div>
            <div style={{padding: 12, display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: 300}}>
              <StandardButton
                text="Close"
                primary={false}
                size='small'
                onClick={() => this.togglePopUp()}/>

              <StandardButton
                text="Buy Coins"
                primary={true}
                size={'small'}
                onClick={() => window.location.assign("/pricing?one_time=true")}/>
            </div>
          </StandardModal>
        }
      </div>
    )
  }
}

export default BuyConnectButton;
